/* angular:styles/component:css;12fbefbeb1760d11ba3bf3b2ea6c0f9b66155c000ae0a9750a23ddfc0bd23a6f;/src/src/app/shared/components/navigation/view/view.ts */
:host {
  height: 100%;
  font-size: 0.9em;
}
:host ion-grid {
  display: inline !important;
}
/*# sourceMappingURL=view.css.map */
